import { render } from "./section2.vue?vue&type=template&id=0e340176"
import script from "./section2.vue?vue&type=script&lang=js"
export * from "./section2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__